import type { FC } from 'react'
import { WizardModal } from '@/common/components'
import { useOnboardingState } from '../hooks'
import { OnboardingWizard } from './OnboardingWizard'

export const OnboardingGate: FC = () => {
  const { shouldShowOnboarding, wizardSteps, isReturningUser, isInitializing, dismissOnboarding } =
    useOnboardingState()

  if (isInitializing) return null

  if (!shouldShowOnboarding) return null

  return (
    <WizardModal
      open={shouldShowOnboarding}
      onClose={dismissOnboarding}
      maxWidth="sm"
      hideCloseButton
    >
      <OnboardingWizard
        steps={wizardSteps}
        isReturningUser={isReturningUser}
        onClose={dismissOnboarding}
      />
    </WizardModal>
  )
}
